import { SectionTypes } from "../../../../resources/modelTypes";

// Constants for height calculations
export const FULL_HEIGHT = window.innerHeight - 100;
// Not quite half height to account for header
export const HALF_HEIGHT = window.innerHeight * 0.6;
export const SHORT_HEIGHT = window.innerHeight * 0.4;

/**
 * Enum representing all possible SwipePanel views in the mobile experience.
 * This includes both content sections and design/settings views.
 */
export enum SwipePanelView {
  // Content sections (from the Add Section list)
  Button = "Button",
  CashRegistry = "CashRegistry",
  Comments = "Comments",
  EventNameDescription = "EventNameDescription",
  Gallery = "Gallery",
  Image = "Image",
  ImageAndText = "ImageAndText",
  Registry = "Registry",
  Text = "Text",
  WebsiteURL = "WebsiteURL",
  Event = "event",

  // Section type picker, shown before a type is chosen
  SelectSectionType = "SelectSectionType",

  // Design/Settings views
  EditColors = "EditColors",
  EditDesign = "EditDesign",
  EditFonts = "EditFonts",
}

/**
 * Height configuration for each SwipePanel view
 */
export const PANEL_HEIGHTS: Record<SwipePanelView, number> = {
  // Content sections - short height
  [SwipePanelView.Text]: SHORT_HEIGHT,
  [SwipePanelView.WebsiteURL]: SHORT_HEIGHT,
  [SwipePanelView.Button]: SHORT_HEIGHT,
  [SwipePanelView.Image]: SHORT_HEIGHT,

  // Content sections - half height
  [SwipePanelView.EventNameDescription]: HALF_HEIGHT,
  [SwipePanelView.Registry]: HALF_HEIGHT,
  [SwipePanelView.ImageAndText]: HALF_HEIGHT,

  // Content sections - full height for complex forms
  [SwipePanelView.CashRegistry]: FULL_HEIGHT,
  [SwipePanelView.Comments]: FULL_HEIGHT, // Technically unused
  [SwipePanelView.Gallery]: FULL_HEIGHT,
  [SwipePanelView.Event]: FULL_HEIGHT,
  [SwipePanelView.SelectSectionType]: FULL_HEIGHT,

  // Design views
  [SwipePanelView.EditColors]: SHORT_HEIGHT,
  [SwipePanelView.EditDesign]: HALF_HEIGHT,
  [SwipePanelView.EditFonts]: HALF_HEIGHT,
};

/**
 * Maps SectionTypes to SwipePanelView for content sections
 */
export const SECTION_TYPE_TO_PANEL_VIEW: Partial<
  Record<SectionTypes, SwipePanelView>
> = {
  [SectionTypes.Anchor]: SwipePanelView.WebsiteURL,
  [SectionTypes.Button]: SwipePanelView.Button,
  [SectionTypes.CashRegistry]: SwipePanelView.CashRegistry,
  [SectionTypes.Comments]: SwipePanelView.Comments,
  [SectionTypes.Gallery]: SwipePanelView.Gallery,
  [SectionTypes.ImageAndText]: SwipePanelView.ImageAndText,
  [SectionTypes.Media]: SwipePanelView.Image,
  [SectionTypes.Registry]: SwipePanelView.Registry,
  [SectionTypes.Text]: SwipePanelView.Text,
  [SectionTypes.Event__FAKE]: SwipePanelView.Event,
};

/**
 * Converts a SectionType to a SwipePanelView
 * Defaults to Text panel view if no mapping exists
 */
export const sectionTypeToSwipePanelView = (
  sectionType: SectionTypes,
): SwipePanelView => {
  return SECTION_TYPE_TO_PANEL_VIEW[sectionType] ?? SwipePanelView.Text;
};
